module.exports = __webpack_public_path__ + "static/djawn_logo-98ca97a73d31ca442470a4bcb2c40915.png";